window.addEventListener('load', function () {
  const script = document.createElement('script');
  script.src = "https://www.gstatic.com/shopping/merchant/merchantwidget.js";
  script.onload = function() {
    if (window.merchantwidget) {
      merchantwidget.start({
        merchant_id: 5677278272,
        position: 'bottom_right',
        region: 'SE'
      });
      console.log('Merchant widget started.');
    } else {
      console.warn('Merchant widget did not load.');
    }
  };
  document.body.appendChild(script);
});
